import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Shared singleton MSAL instance for the entire app
export const msalInstance = new PublicClientApplication(msalConfig);

// Promise to ensure MSAL client is initialized
export const msalInitPromise = msalInstance.initialize();